import React, { type FC } from 'react';
import Button from '@atlaskit/button';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { Link } from '@atlassian/react-resource-router';
import messages from './messages';

export const UpgradeButton: FC = () => {
	const { formatMessage } = useIntl();
	const isSiteAdmin = useIsSiteAdmin();

	if (isSiteAdmin) {
		return (
			<Button
				href="/admin/billing/applications/change-edition/jira-servicedesk.ondemand"
				component={Link}
				appearance="primary"
				target="_blank"
				onClick={(_event, analyticsEvent) => {
					// https://data-portal.internal.atlassian.com/analytics/registry/58039
					fireUIAnalytics(analyticsEvent, 'virtualAgentUpgrade');
				}}
			>
				{formatMessage(messages.upgradeButton)}
			</Button>
		);
	}

	return (
		<Button
			component={Link}
			appearance="primary"
			onClick={(_event, analyticsEvent) => {
				// https://data-portal.internal.atlassian.com/analytics/registry/57979
				fireUIAnalytics(analyticsEvent, 'virtualAgentPricingPlans');
			}}
			href="https://www.atlassian.com/software/jira/service-management/pricing"
		>
			{formatMessage(messages.viewPricingPlansButton)}
		</Button>
	);
};
